import React from 'react';

import { DatasetResource } from '../../../shared/api/api';
import { FormattedMessageHelper } from '../../../shared/helpers/internationalization';
import analytics from '../../../shared/services/analytics/analytics';
import { addModifiers } from '../../../shared/helpers';
import { Popup } from 'semantic-ui-react';

interface ListResourcesProps {
  resources: DatasetResource[];
}

export const renderEmojiByResourceType = (type: string) => {
  return (
    <Popup
      on="hover"
      size="tiny"
      position="top center"
      inverted={true}
      content={<FormattedMessageHelper id={`dataExplorer.dataset.resources.${type}.title`} />}
      trigger={
        <span>
          <FormattedMessageHelper tagName="" id={`dataExplorer.dataset.resources.${type}.emoji`} />
        </span>
      }
    />
  );
};

export function ListResources({ resources }: ListResourcesProps) {
  const handleClickResource = React.useCallback((event: React.MouseEvent<HTMLAnchorElement>) => {
    const title = event.currentTarget.getAttribute('data-title')!;
    analytics.trackCustomEvent('click_resource', { event_label: title });
  }, []);

  return (
    <>
      <h2>
        <FormattedMessageHelper id="dataExplorer.dataset.resources" />
      </h2>
      <div className="data-single-entity__resources">
        <ul>
          {resources.map(resource => (
            <li key={resource.url}>
              <div>
                {renderEmojiByResourceType(resource.type)}
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={resource.url}
                  data-title={resource.title}
                  className={addModifiers('link', ['wrap'])}
                  onClick={handleClickResource}
                >
                  <span>{resource.title}</span>
                </a>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
}
